import {
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
} from "@chakra-ui/react";
import DrawerFormFooter from "components/Shared/DrawerForm/DrawerFormFooter";
import Form from "./Form";
import { useCreateRetailer } from "./useCreateRetailer";

const FORM_ID = "create-retailer-form";

type Props = {
  isAdmin?: boolean;
  onCloseEdit: () => void;
  onCompleted: (id: UUID) => void;
};

export default function CreateRetailer({
  isAdmin,
  onCloseEdit,
  onCompleted,
}: Props) {
  const { brandId, handleValidSubmit, isSaving } = useCreateRetailer(isAdmin);

  return (
    <DrawerContent bg="cardBackground">
      <DrawerCloseButton />
      <DrawerHeader>Create Retailer</DrawerHeader>
      <DrawerBody>
        <Form
          formId={FORM_ID}
          isAdmin={isAdmin}
          onValidSubmit={(formData, context) =>
            handleValidSubmit(formData, context).then((result) => {
              const newId = result?.data?.createRetailer?.retailer?.id;
              if (newId) onCompleted(newId);
            })
          }
          parentSelectFilter={{
            forBrandId: { equalTo: isAdmin ? null : brandId },
          }}
        />
      </DrawerBody>
      <DrawerFormFooter
        onClose={onCloseEdit}
        formId={FORM_ID}
        submitButtonProps={{
          isLoading: isSaving,
        }}
      />
    </DrawerContent>
  );
}
